import React from "react";
import { Sparkles, CheckCircle2 } from "lucide-react";

const BENEFITS = [
  "Faire revenir l'être aimé",
  "Briser les liens toxiques",
  "Développer votre activité",
  "Retrouver joie et sérénité",
  "Réussir travail & examens",
  "Confiance en soi & charisme",
  "Raviver la passion sexuelle",
  "Désenvoûtement puissant",
  "Protection du foyer",
  "Soins traditionnels africains"
];

export default function AboutSection() {
  return (
    <section className="section-vignette py-20">
      <div className="container-narrow grid md:grid-cols-5 gap-12 items-center">
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Qui est Maître Diamma ?</p>
          <h2 className="font-display text-3xl md:text-4xl gold-gradient-text mb-6">Un héritier des grands maîtres africains à Orléans</h2>
          <div className="gold-divider mb-6" />
          <p className="text-gold-soft/95 leading-relaxed mb-4">
            Initié dès l'enfance par les anciens de sa famille, Maître Diamma a reçu les <span className="text-gold">secrets ancestraux</span> transmis de génération en génération. Installé au cœur d'Orléans, il consacre sa vie à soulager, réconcilier et protéger les habitants de la métropole et du Loiret : Olivet, Fleury-les-Aubrais, Saran, Saint-Jean-de-Braye, Montargis, Gien, Pithiviers, Beaugency…
          </p>
          <p className="text-gold-soft/95 leading-relaxed mb-6">
            Sa force ? Une écoute profonde, une lecture immédiate des énergies et une <span className="text-gold">honnêteté rare</span>. Dès le premier appel, gratuit et sans engagement, il vous dit exactement ce qu'il peut faire pour vous — ni plus, ni moins. Il respecte chaque croyance et adapte ses rituels à chaque histoire.
          </p>
          <ul className="grid sm:grid-cols-2 gap-3">
            {BENEFITS.map((it) => (
              <li key={it} className="flex items-start gap-2 text-sm text-gold-soft/95">
                <CheckCircle2 className="w-4 h-4 text-gold mt-0.5" /> {it}
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="relative rounded-xl overflow-hidden gold-border-strong">
            <img src="/images/diamma-blanc.jpg" alt="Maître Diamma, marabout africain au centre d'Orléans" className="w-full h-[360px] md:h-[520px] object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
              <div className="w-12 h-12 rounded-full gold-border flex items-center justify-center bg-black/60">
                <Sparkles className="w-6 h-6 text-gold" />
              </div>
              <div>
                <div className="font-display text-gold-soft">Lignée sacrée</div>
                <div className="text-xs text-gold-deep">Afrique de l'Ouest → Orléans</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
